import { defineStore } from 'pinia';
import { ref } from 'vue';

/** UI compartida entre `BaseLayout` (botón en cabecera) y `MensajeChat` (filtro de lista). */
export const useChatMensajesUiStore = defineStore('chatMensajesUi', () => {
  const showOnlyUnread = ref(false);
  const unreadIncomingCount = ref(0);

  function setUnreadIncomingCount(n: number) {
    unreadIncomingCount.value = n;
    if (showOnlyUnread.value && n === 0) {
      showOnlyUnread.value = false;
    }
  }

  function reset() {
    showOnlyUnread.value = false;
    unreadIncomingCount.value = 0;
  }

  function toggleShowOnlyUnread() {
    if (showOnlyUnread.value) {
      showOnlyUnread.value = false;
      return;
    }
    if (unreadIncomingCount.value <= 0) return;
    showOnlyUnread.value = true;
  }

  return {
    showOnlyUnread,
    unreadIncomingCount,
    setUnreadIncomingCount,
    reset,
    toggleShowOnlyUnread,
  };
});
